var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotate-clockwise-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01949 12.6933C9.15451 12.6967 10.2519 12.2863 11.1061 11.539C11.9604 10.7916 12.513 9.75858 12.6605 8.63318C12.7084 8.26812 13.0431 8.01096 13.4082 8.05881C13.7733 8.10667 14.0304 8.4414 13.9826 8.80647C13.7929 10.2534 13.0824 11.5816 11.984 12.5425C10.8857 13.5034 9.47482 14.031 8.0155 14.0266C6.55619 14.0223 5.14848 13.4862 4.05591 12.5188C2.96333 11.5514 2.26078 10.2189 2.07977 8.77088C1.89877 7.32283 2.25171 5.85844 3.07254 4.65185C3.89336 3.44526 5.1258 2.57917 6.53914 2.21573C7.95248 1.85228 9.44983 2.01639 10.7509 2.67733C11.489 3.05229 12.1352 3.57256 12.6549 4.20013V2.71983C12.6549 2.35164 12.9533 2.05316 13.3215 2.05316C13.6897 2.05316 13.9882 2.35164 13.9882 2.71983V6.05316C13.9882 6.42135 13.6897 6.71983 13.3215 6.71983H13.0037C12.9935 6.72006 12.9833 6.72006 12.9731 6.71983H9.98821C9.62002 6.71983 9.32154 6.42135 9.32154 6.05316C9.32154 5.68497 9.62002 5.38649 9.98821 5.38649H11.8815C11.4427 4.74701 10.8482 4.22225 10.147 3.86607C9.13508 3.35201 7.97047 3.22437 6.8712 3.50705C5.77194 3.78973 4.81338 4.46335 4.17496 5.40181C3.53654 6.34027 3.26203 7.47924 3.40281 8.6055C3.5436 9.73176 4.09002 10.7681 4.9398 11.5205C5.78959 12.273 6.88446 12.6899 8.01949 12.6933Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.1f93f4eea211991399c922f439e9d5b4.svg";
export { ForwardRef as ReactComponent };